module.exports = __webpack_public_path__ + "static/cb1000x500-82326dcba12a85748089f24e86aa6318.png";